import { ReactNode } from 'react'
import {
  ArticulatedDumpTruckCategoryIcon,
  BulldozerCategoryIcon,
  BusCategoryIcon,
  CompactorRollerCategoryIcon,
  DrillRigCategoryIcon,
  ExcavatorCategoryIcon,
  FuelTruckCategoryIcon,
  GeneratorCategoryIcon,
  HaulTruckCategoryIcon,
  LightVehicleCategoryIcon,
  MobileCraneCategoryIcon,
  MotorGraderCategoryIcon,
  ServiceTruckCategoryIcon,
  TowerLightCategoryIcon,
  WaterTruckCategoryIcon,
  WheelLoaderCategoryIcon,
} from 'assets/icons/machineCategories/MachineCategoryIcons'
import { tokens } from 'styling/tokens'

export interface IMachineCategoryIconOption {
  iconName: string
  label: string
}

export const MACHINE_CATEGORY_ICON_OPTIONS: IMachineCategoryIconOption[] = [
  { iconName: 'excavator', label: 'Excavator' },
  { iconName: 'haul-truck', label: 'Haul Truck' },
  { iconName: 'articulated-dump-truck', label: 'Articulated Dump Truck' },
  { iconName: 'bulldozer', label: 'Bulldozer' },
  { iconName: 'wheel-loader', label: 'Wheel Loader' },
  { iconName: 'motor-grader', label: 'Motor Grader' },
  { iconName: 'compactor-roller', label: 'Compactor / Roller' },
  { iconName: 'drill-rig', label: 'Drill Rig' },
  { iconName: 'mobile-crane', label: 'Mobile Crane' },
  { iconName: 'water-truck', label: 'Water Truck' },
  { iconName: 'fuel-truck', label: 'Fuel Truck' },
  { iconName: 'service-truck', label: 'Service Truck' },
  { iconName: 'light-vehicle', label: 'Light Vehicle' },
  { iconName: 'bus', label: 'Bus' },
  { iconName: 'generator', label: 'Generator' },
  { iconName: 'tower-light', label: 'Tower Light' },
]

export const getMachineCategoryIcon = (
  iconName?: string | null,
  color: string = tokens.accent.base,
  size = 20,
): ReactNode => {
  switch (iconName) {
    case 'excavator':
      return <ExcavatorCategoryIcon color={color} size={size} />
    case 'haul-truck':
      return <HaulTruckCategoryIcon color={color} size={size} />
    case 'articulated-dump-truck':
      return <ArticulatedDumpTruckCategoryIcon color={color} size={size} />
    case 'bulldozer':
      return <BulldozerCategoryIcon color={color} size={size} />
    case 'wheel-loader':
      return <WheelLoaderCategoryIcon color={color} size={size} />
    case 'motor-grader':
      return <MotorGraderCategoryIcon color={color} size={size} />
    case 'compactor-roller':
      return <CompactorRollerCategoryIcon color={color} size={size} />
    case 'drill-rig':
      return <DrillRigCategoryIcon color={color} size={size} />
    case 'mobile-crane':
      return <MobileCraneCategoryIcon color={color} size={size} />
    case 'water-truck':
      return <WaterTruckCategoryIcon color={color} size={size} />
    case 'fuel-truck':
      return <FuelTruckCategoryIcon color={color} size={size} />
    case 'service-truck':
      return <ServiceTruckCategoryIcon color={color} size={size} />
    case 'light-vehicle':
      return <LightVehicleCategoryIcon color={color} size={size} />
    case 'bus':
      return <BusCategoryIcon color={color} size={size} />
    case 'generator':
      return <GeneratorCategoryIcon color={color} size={size} />
    case 'tower-light':
      return <TowerLightCategoryIcon color={color} size={size} />
    default:
      return <BulldozerCategoryIcon color={color} size={size} />
  }
}
